import styled from 'styled-components'
export const ContainerNews = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 2rem 9rem;
  form {
    width: 100%;
  }
`
